





















import { Vue, Component, Prop } from "vue-property-decorator";
import { Params } from "@/modules/SspDataModule";

@Component
export default class extends Vue {
  @Prop({ required: true })
  params!: Params["sdssTrueColor"]

  get logBeta() {
    return Math.log(this.params.beta)
  }
  set logBeta(beta: number) {
    this.params.beta = Math.exp(beta)
  }
}
